import React, { useState,useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';


function ChangePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate()

  const [imgError, setImgError] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (password !== confirmPassword) {
    Swal.fire({
      icon: 'warning',
      title: 'Mismatch',
      text: 'Password and Confirm Password do not match',
    });
    return;
  }

  const token = localStorage.getItem('token');
  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Not Authenticated',
      text: 'Please log in again.',
    });
    navigate('/login'); 
    return;
  }

  try {
    const response = await axios.post(
      'https://codydealms.codydeasoftech.in/api/teacher/changePassword',
      {
        password,
        confirm_password: confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.status === true) {
      Swal.fire({
        title: 'Success',
        text: response.data.message,
        icon: 'success',
        timer: 3000,
        showConfirmButton: false,
      });
      setPassword('');
      setConfirmPassword('');
      navigate('/dashboard');
    } else {
      Swal.fire({
        title: 'Failed',
        text: response.data.message || 'Password change failed.',
        icon: 'error',
      });
    }
  } catch (error) {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || 'Server error occurred.';

    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      Swal.fire({
        icon: 'error',
        title: 'Session Expired',
        text: 'Your session has expired. Please log in again.',
      }).then(() => {
        navigate('/login');
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: message,
        icon: 'error',
      });
    }
  }
};


useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://codydealms.codydeasoftech.in/api/teacher/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status) {
          setProfile(response.data.data.profile);
          // setFormData({
          //   name: response.data.data.profile.name,
          //   mobile: response.data.data.profile.mobile,
          //   email: response.data.data.profile.email,
          // });
        }
      } catch (error) {
        console.error('Error fetching profile:', error);

        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // Token expired or unauthorized
          localStorage.removeItem('token'); // Clear token
          navigate('/login'); // Redirect to login page
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (!profile) return <div className="text-center mt-5 text-danger">Profile not found.</div>;


//   return (
    

//  <div className="container mt-5 p-5 border rounded bg-light shadow-lg" style={{ maxWidth: '800px' }}>
  

//   <div className="d-flex justify-content-center mb-4">
//       {profile?.filepath && !imgError ? (
//         <img
//           src={profile.filepath}
//           className="rounded-circle border"
//           width="100"
//           height="100"
//           alt="Profile"
//           onError={() => setImgError(true)} // show avatar if image fails
//         />
//       ) : (
//         <div
//           className="rounded-circle d-flex align-items-center justify-content-center border bg-secondary"
//           style={{ width: '100px', height: '100px', color: 'white', fontSize: '36px' }}
//         >
//           <i className="fas fa-user"></i>
//         </div>
//       )}
//     </div>



//   {/* Name and Email */}
//   <div className="text-center mb-4">
//     <h5 className="mb-1">{profile.name}</h5>
//     <p className="mb-0 text-muted">{profile.email}</p>
//   </div>

//   {/* Change Password Form */}
//       <form onSubmit={handleSubmit}>
//         {/* New Password */}
//         <div className="mb-3 position-relative">
//           <i className="fas fa-lock position-absolute" style={{
//             left: '10px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             color: '#999'
//           }}></i>

//           <input
//             type={showPassword ? 'text' : 'password'}
//             className="form-control ps-5 pe-5"
//             placeholder="New Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />

//           <i
//             className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} position-absolute`}
//             style={{
//               right: '10px',
//               top: '50%',
//               transform: 'translateY(-50%)',
//               cursor: 'pointer',
//               color: '#999'
//             }}
//             onClick={() => setShowPassword(!showPassword)}
//           ></i>
//         </div>

//         {/* Confirm Password */}
//         <div className="mb-4 position-relative">
//           <i className="fas fa-lock position-absolute" style={{
//             left: '10px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             color: '#999'
//           }}></i>

//           <input
//             type={showConfirmPassword ? 'text' : 'password'}
//             className="form-control ps-5 pe-5"
//             placeholder="Confirm Password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             required
//           />

//           <i
//             className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'} position-absolute`}
//             style={{
//               right: '10px',
//               top: '50%',
//               transform: 'translateY(-50%)',
//               cursor: 'pointer',
//               color: '#999'
//             }}
//             onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//           ></i>
//         </div>

//         <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: '#5856d6' }}>
//           Change Password
//         </button>
//       </form>
// </div>



//   );

return (
  <div className="container mt-5 p-5 border rounded bg-light shadow-lg" style={{ maxWidth: '800px' }}>
    {/* Profile Image */}
    <div className="d-flex justify-content-center mb-4">
      {profile?.filepath && !imgError ? (
        <img
          src={profile.filepath}
          className="rounded-circle border"
          width="100"
          height="100"
          alt="Profile"
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className="rounded-circle d-flex align-items-center justify-content-center border bg-secondary"
          style={{ width: '100px', height: '100px', color: 'white', fontSize: '36px' }}
        >
          <i className="fas fa-user"></i>
        </div>
      )}
    </div>

    {/* Name and Email */}
    <div className="text-center mb-4">
      <h5 className="mb-1">{profile.name}</h5>
      <p className="mb-0 text-muted">{profile.department_name}</p>
    </div>

    {/* Change Password Form */}
    <form onSubmit={handleSubmit}>
      <div className="row">
        {/* Full Name (col-12, disabled) */}
        <div className="col-12 mb-4">
          <label className="form-label fw-bold">Full Name</label>
          <input
            type="text"
            className="form-control border-0 border-bottom"
            value={profile.name}
            disabled
          />
        </div>

        <div className="col-6 mb-4">
          <label className="form-label fw-bold">Email</label>
          <input
            type="text"
            className="form-control border-0 border-bottom"
            value={profile.email}
            disabled
          />
        </div>

        <div className="col-6 mb-4">
          <label className="form-label fw-bold">Phone No.</label>
          <input
            type="text"
            className="form-control border-0 border-bottom"
            value={profile.mobile}
            disabled
          />
        </div>

        {/* <h5>Change Password</h5> */}

        {/* New Password */}
        <div className='mb-4 col-6'>
          <label className='fw-bold form-label'>New Password <span className='text-danger'>*</span></label>
          <div className="mb-3 position-relative">
            <i className="fas fa-lock position-absolute" style={{
              left: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#999'
            }}></i>

            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control ps-5 pe-5"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <i
              className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} position-absolute`}
              style={{
                right: '24px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#999'
              }}
              onClick={() => setShowPassword(!showPassword)}
            ></i>
          </div>
        </div>

        {/* Confirm Password */}
        <div className='col-6'>
          <label className='fw-bold form-label'>Confirm Password <span className='text-danger'>*</span></label>
          <div className="mb-3 position-relative">
            <i className="fas fa-lock position-absolute" style={{
              left: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#999'
            }}></i>

            <input
              type={showConfirmPassword ? 'text' : 'password'}
              className="form-control ps-5 pe-5"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <i
              className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'} position-absolute`}
              style={{
                right: '24px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#999'
              }}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            ></i>
          </div>
        </div>
      </div>

      <button
        type="submit"
        className="btn w-100 text-white"
        style={{ backgroundColor: '#5856d6' }}
      >
        Change Password
      </button>
    </form>
  </div>
);

}

export default ChangePassword;
